import React, { FC, useState } from 'react';
import AdvertisingTable from '../../components/Admin/Tables/AdvertisingTable/AdvertisingSettings/AdvertisingSettingsTable';
import ContentHeader from '../../components/Admin/ContentHeader';
import classes from './AdvertisingPage.module.scss';

export type ContentType = {
  id?: number;
  title: string;
};

type SettingsItemType = {
  id: number;
  elementTitle: string;
  currentData: ContentType[];
  isActive: boolean;
};

export enum AdvertisingElements {
  VideoPlaylist = 'Табло видео'
}

const tableName = 'Реклама';
const tabs = [{ data: 'settings', tabText: 'Настройки' }];

const AdvertisingPage: FC = () => {
  const [activeTab, setActiveTab] = useState<string>(tabs[0].data);
  const settingsData: SettingsItemType[] = [];

  return (
    <div className={classes.container}>
      <ContentHeader handleClickTabs={setActiveTab} tabs={tabs} name={tableName} />
      {activeTab === tabs[0].data && (
        <AdvertisingTable
          setIsModalEditPlaylistActive={() => {}}
          advertisingSettingsData={settingsData}
          isLoadingData={false}
        />
      )}
    </div>
  );
};

export default AdvertisingPage;
